<template>
    <BaseCard class="relative flex flex-col items-start gap-2 overflow-hidden text-ink-muted">
        <div class="shrink-0">
            <img :src="CollabProfileIcon" :alt="t('chat.home.collaborationProfile.iconAlt')" class="h-10.5 w-auto" />
        </div>
        <div class="flex flex-col w-full gap-1">
            <div class="text-ink nadia-subtitle leading-6.5">{{ t("chat.home.collaborationProfile.title") }}</div>
            <div class="body-small text-ink-muted mt-1">{{ t("chat.home.collaborationProfile.description") }}</div>
        </div>
        <BaseButton theme="secondary" class="w-full mt-auto" @click="handleClick">{{ t("chat.home.collaborationProfile.cta") }}</BaseButton>
    </BaseCard>
</template>

<script setup lang="ts">
import CollabProfileIcon from "~img/collab-profile-icon.png";
import BaseButton from "~vue/components/BaseButton.vue";
import BaseCard from "~vue/components/BaseCard.vue";
import { openUrl } from "~vue/utils";
import AmplitudeEventNames from "~vue/utils/amplitudeEventNames";
import { logUserInteraction } from "~vue/utils/logUtils";
import { onMounted } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const props = withDefaults(
    defineProps<{
        hasPerspectiveResult?: boolean;
    }>(),
    { hasPerspectiveResult: false },
);

onMounted(() => {
    logUserInteraction(AmplitudeEventNames.COLLABORATION_PROFILE_CARD_SHOWN);
});

const handleClick = () => {
    logUserInteraction(AmplitudeEventNames.COLLABORATION_PROFILE_CARD_CLICKED);
    openUrl(props.hasPerspectiveResult ? "/profile/create?auto_generate=true" : "/profile/create");
};
</script>
